import { Grid, GridItem, useDisclosure } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useQueryState } from '../../../hooks/useQueryState'
import { GenerateImageResponse } from '../../../interfaces'
import ExpandImageModal from './ExpandImageModal'
import GenerateImagePreview from './GenerateImagePreview'
import HistoryImagePreview from './HistoryImagePreview'

interface ImageGalleryProps {
  generatedImages: GenerateImageResponse[]
  preview: 'history' | 'generate'
  refetch?: () => void
  handleImageLoaded?: (index: number, loaded: boolean) => void
}

const ImageGallery = ({ generatedImages, preview, refetch, handleImageLoaded }: ImageGalleryProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const [selectedImageId] = useQueryState<string | null>(
    null,
    'selectedImageId',
  )
  const [tabIndex] = useQueryState<string>('history', 'tab')
  const ImagePreview =
    preview === 'history' ? HistoryImagePreview : GenerateImagePreview

  useEffect(() => {
    if (tabIndex === 'history' && !isOpen && selectedImageId) {
      onOpen()
    }
  }, [])

  return (
    <>
      <Grid
        gridTemplateColumns={[
          'repeat(1, minmax(8px, 1fr))',
          'repeat(2, minmax(8px, 1fr))',
          'repeat(4, minmax(8px, 1fr))',
        ]}
        gap={4}
      >
        {generatedImages.map((image, index) => {
          return (
            <GridItem key={image.imageId} position="relative">
              <ImagePreview
                generatedImages={generatedImages}
                index={index}
                onOpen={onOpen}
                setCurrentIndex={setCurrentIndex}
                handleImageLoaded={handleImageLoaded}
              />
            </GridItem>
          )
        })}
      </Grid>
      <ExpandImageModal
        isOpen={isOpen}
        onClose={onClose}
        generatedImages={generatedImages}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        refetch={refetch}
      />
    </>
  )
}

export default ImageGallery
